import { Head, Link, router } from '@inertiajs/react'
import React from 'react'
import Layout from './Layout'
import VenueCard from './Components/VenueCard'
import EventTypeCard from './Components/EventTypeCard'
import AccountBadge from '../GuestOrder/Components/AccountBadge'
import PhoneButton from '../../Components/PhoneButton'

export default function Home({ account, view, venues = [], event_types = [], has_event_types, bookings_enabled, meta }) {
  const handleSelectVenue = (venueId) => {
    router.visit(`/${account.slug}/booking/venues/${venueId}`)
  }

  if (!bookings_enabled) {
    return (
      <>
        <Head title={meta.title} />
        <Layout account={account}>
          <div className="flex flex-col items-center justify-center min-h-[80vh] px-4 text-center">
            <div className="mb-8">
              <div className="flex justify-center mb-4">
                <AccountBadge name={account.name} size="md" />
              </div>
              <h1 className="text-2xl font-bold text-white">{account.name}</h1>
              <p className="text-sky-200 mt-1">Venue Booking</p>
            </div>

            <div className="bg-white rounded-2xl p-8 w-full max-w-md">
              <div className="text-5xl mb-4" aria-hidden="true">
                <svg className="w-16 h-16 mx-auto text-sky-900" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">Coming Soon</h2>
              <p className="text-gray-600 mb-6">
                Online venue booking is coming soon. In the meantime, please call us to discuss your event.
              </p>
              <PhoneButton phoneNumber={account.phone}>
                Call us to book
              </PhoneButton>
            </div>
          </div>
        </Layout>
      </>
    )
  }

  if (view === 'occasions') {
    return (
      <>
        <Head title={meta.title} />
        <Layout account={account} wide>
          <div className="px-4 pt-6 pb-6 text-center">
            <div className="flex justify-center mb-4">
              <AccountBadge name={account.name} size="md" />
            </div>
            <h1 className="text-2xl font-bold text-white">{account.name}</h1>
            <p className="text-sky-200 mt-1">What are you planning?</p>
          </div>

          <div className="px-4 pb-6">
            <div className="grid grid-cols-2 gap-3 max-w-2xl mx-auto">
              {event_types.map(eventType => (
                <EventTypeCard
                  key={eventType.id}
                  eventType={eventType}
                  accountSlug={account.slug}
                />
              ))}
            </div>
          </div>

          <div className="px-4 pb-8 text-center">
            <Link
              href={`/${account.slug}/booking?view=rooms`}
              className="text-sky-200 hover:text-white text-sm underline underline-offset-2"
            >
              Planning something else? Browse our rooms
            </Link>
          </div>

          {account.phone && (
            <div className="px-4 pb-8 max-w-md mx-auto">
              <PhoneButton
                phoneNumber={account.phone}
                className="!bg-transparent !text-sky-200 hover:!text-white border border-sky-200/30"
              >
                Prefer to call? Speak to our team
              </PhoneButton>
            </div>
          )}
        </Layout>
      </>
    )
  }

  return (
    <>
      <Head title={meta.title} />
      <Layout account={account} wide>
        <div className="px-4 pt-6 pb-6 text-center">
          <div className="flex justify-center mb-4">
            <AccountBadge name={account.name} size="md" />
          </div>
          <h1 className="text-2xl font-bold text-white">{account.name}</h1>
          <p className="text-sky-200 mt-1">Choose a venue to get started</p>
        </div>

        <div className="px-4 pb-6">
          {venues.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {venues.map(venue => (
                <VenueCard
                  key={venue.id}
                  venue={venue}
                  onClick={() => handleSelectVenue(venue.id)}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-8">
              <p className="text-sky-200">No venues available at this time.</p>
              <PhoneButton phoneNumber={account.phone} className="mt-4">
                Call us to discuss your event
              </PhoneButton>
            </div>
          )}
        </div>

        {has_event_types && (
          <div className="px-4 pb-8 text-center">
            <Link
              href={`/${account.slug}/booking`}
              className="text-sky-200 hover:text-white text-sm underline underline-offset-2"
            >
              Planning an occasion? Start with what you're celebrating
            </Link>
          </div>
        )}

        {account.phone && venues.length > 0 && (
          <div className="px-4 pb-8 max-w-md mx-auto">
            <PhoneButton
              phoneNumber={account.phone}
              className="!bg-transparent !text-sky-200 hover:!text-white border border-sky-200/30"
            >
              Prefer to call? Speak to our team
            </PhoneButton>
          </div>
        )}
      </Layout>
    </>
  )
}
